interface StatTileProps { label: string; value: string; icon: string; tone: string }

// tone sets the soft background and icon color of the tile.
export default function StatTile({ label, value, icon, tone }: StatTileProps) {
  return (
    <div className="bg-white border border-background-200 rounded-2xl p-5">
      <span className={`w-9 h-9 flex items-center justify-center rounded-lg ${tone}`}>
        <i className={`${icon} text-lg`} aria-hidden="true" />
      </span>
      <p className="mt-4 text-sm text-foreground-600">{label}</p>
      <p className="mt-1 text-[28px] leading-9 font-bold text-foreground-950 break-words">{value}</p>
    </div>
  );
}
